<template>
  <v-slide-y-transition>
    <div v-if="adding" class="mb-3">
      <Qualification
        :requestGraduationDate="requestGraduationDate"
        :qualification="adding"
        :profile="profile"
        @refresh="refresh"
        :hideStartsAt="hideStartsAt"
        :hideEndsAt="hideEndsAt"
      />
    </div>
    <div v-else-if="withButton" class="text-xs-center pt-4">
      <v-chip
        slot="activator"
        :class="{ 'w-full': $vuetify.breakpoint.xsOnly }"
        class="candidate add-qualification-button"
      >
        <v-avatar>
          <v-btn
            slot="activator"
            :color="themes.candidate.light.secondaryActionButton"
            @click="createQualification"
            small
            fab
            class="elevation-1"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-avatar>
        <span :class="{ 'overflow--ellipsis': $vuetify.breakpoint.xsOnly }">{{ label }}</span>
      </v-chip>
    </div>
  </v-slide-y-transition>
</template>

<script>
import Qualification from '@/components/candidate/profile/edit/qualifications/Qualification'

export default {
  components: { Qualification },

  props: {
    hideEndsAt: { type: Boolean, default: false },
    hideStartsAt: { type: Boolean, default: false },
    label: { type: String, default: 'Add a qualification' },
    profile: { type: Object, required: true },
    requestGraduationDate: { type: Boolean, default: true },
    value: { type: Boolean },
    withButton: { type: Boolean, default: false },
  },

  data() {
    return {
      adding: null,
    }
  },

  watch: {
    value: {
      handler: function(value) {
        if (value) this.createQualification()
      },
      immediate: true,
    },
    adding: function(value) {
      this.$emit('input', !!value)
    },
  },

  methods: {
    createQualification() {
      this.adding = {
        institution: {},
        institutionName: '',
        qualification: {},
        qualificationType: {},
        qualificationTypeName: '',
        specialization: '',
      }
    },

    refresh() {
      this.adding = null
      this.$emit('refresh')
    },
  },
}
</script>

<style lang="scss">
.candidate.add-qualification-button {
  .w-full {
    width: 100%;
    max-width: 100%;

    > span {
      max-width: 100%;
    }

    .overflow--ellipsis {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
